import empterm from './empterm';
import orgterm from './orgterm';
import empyear from './empyear';
import orgyear from './orgyear';
import emptermExt from './emptermExt';
import emptermEmpCourse from './emptermEmpCourse';
import emptermbytime from './emptermbytime';
import emptermbytime2 from './emptermbytime2';
import empyearssti from './empyearssti';
import empyearssti2 from './empyearssti2';

export default {
    empterm,
    orgterm,
    empyear,
    orgyear,
    emptermExt,
    emptermEmpCourse,
    emptermbytime,
    emptermbytime2,
    empyearssti,
    empyearssti2
}